import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ProgressService } from './progress-service';

@Component({
  selector: 'tvd-progress',
  host: {
    class: 'w-full block h-[2px] overflow-hidden',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="relative">
      <
      <div
        [style.--progress-scale-x]="progress() / 100"
        class="absolute inset-0 bg-primary w-full origin-left"
        style="transform: scaleX(var(--progress-scale-x));"
      ></div>
    </div>
  `,
})
export class Progress {
  readonly progress = inject(ProgressService).progress;
}
